import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { Box, Typography } from "@mui/material";

import {
	formatDuration,
	type RFactorPerStandData,
} from "../models/RFactorPerStand";

interface Props {
	data: RFactorPerStandData;
}

// A point is an R-Factor change, not a billet, and the axis is not clock time.
// Both are easy to misread from the chart alone, so they are stated here. When
// there is nothing plotted the chart area says why, and this line stays out of
// the way.
export const RFactorPerStandSummary = ({ data }: Props) => {
	const { points, hollows } = data;

	if (!points.length) return null;

	const first = dxtToLocalServerTime(
		new Date(points[0].start),
		"MM/dd/yyyy HH:mm",
	);
	const last = dxtToLocalServerTime(
		new Date(points[points.length - 1].start),
		"MM/dd/yyyy HH:mm",
	);
	const gapSeconds = hollows.reduce((sum, h) => sum + h.seconds, 0);

	// Three facts the chart cannot show on its own: how many points there are, the
	// range that actually carries data rather than the one that was asked for, and
	// that a stretch of time was taken out of the axis. What each mark means is on
	// the mark itself and in its tooltip; repeating it here was too much.
	return (
		<Box sx={{ px: 0.5 }}>
			<Typography variant="caption" color="text.secondary">
				{`${points.length.toLocaleString()} R-Factor ${
					points.length === 1 ? "change" : "changes"
				} · ${first} to ${last}`}
				{hollows.length
					? ` · ${hollows.length} ${
							hollows.length === 1 ? "gap" : "gaps"
						} skipped, ${formatDuration(gapSeconds)}`
					: ""}
			</Typography>
		</Box>
	);
};
